export default Object.freeze({
  OFTALMOLOGIA: 'Oftalmologia',
  // DERMATOLOGIA: 'dermatologia',
});
